export default __webpack_public_path__ + "user-icon.png?610bf97afc184dc400afcab68569130f";